<fa-icon *ngIf="icon" [icon]="icon"></fa-icon>
